import React, { Component } from 'react';

import moment from "moment";
import swal from 'sweetalert2';
import {SkyLightStateless} from 'react-skylight';

import {apiToken} from "../../../utils/headers";
import urls from "../../../utils/urls";


export default class Sidebar extends Component {

    constructor(props){
        super(props);

        this.state = {
            showModal: false,
            ajaxInProgress: false
        }
    }

    closeModal = () => {
        this.setState({showModal:false});
    };

    _onSubmitSuccess = () => {
        this.setState({ajaxInProgress: false, showModal: false});
        swal({
            title: 'Descarga realizada',
            type: 'success',
            showConfirmButton: false,
            timer: 3000
        });
    };


    _onSubmitError = () => {
        this.setState({ajaxInProgress: false});
        swal({
            title: 'No se ha podido realizar la descarga',
            html: 'Por favor, vuelva a intentarlo nuevamente',
            type: 'error'
        });
    };

    submitForm = () => {
        this.setState({ajaxInProgress: true});

        let API_URL = `${urls.API_ROOT}/api/v1/api_text/`;
        try{
            let xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                let a;
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    this._onSubmitSuccess();
                    // Trick for making downloadable link
                    a = document.createElement('a');
                    a.href = window.URL.createObjectURL(xhttp.response);
                    // Give filename you wish to download
                    a.download = `Registros API - ${moment().format('DD-MM-YYYY')}.txt`;
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                }else if(xhttp.status >= 300){
                    this._onSubmitError();
                }
            }.bind(this);
            // Post data to URL which handles post request
            xhttp.open("GET", API_URL);
            xhttp.setRequestHeader("Authorization", `Token ${apiToken()}`);
            // You should set responseType as blob for binary responses
            xhttp.responseType = 'blob';
            xhttp.send();
        }
        catch(e){
            console.log(e);
        }

    };

    render() {

        let modalStyle = {
            top: '30%',
            width: 400,
            height: 500,
            maxHeight: 400,
            marginTop: 0,
            marginLeft: -200,
            left: '50%'
        };

        return (
            <div className={'side-bar no-padding'} style={{marginTop:50}}>
                {this.props.data.map(data =>
                    <p key={data.variable} className={data.active ? "side-bar-selected" : "side-bar-unselected"}
                       onClick={()=>{this.props.action(data)}} >{data.name}</p>)
                }
                <p className={"side-bar-unselected pointer"}
                   style={{position: 'fixed', bottom: 0}}
                   onClick={() => this.setState({showModal: true})}
                >
                    Descarga Registros API
                </p>

                <div>
                    <SkyLightStateless
                        onOverlayClicked={this.closeModal}
                        isVisible={this.state.showModal}
                        onCloseClicked={this.closeModal}
                        dialogStyles={modalStyle}
                    >
                        <div className={"modal-title center"}>Descarga Registros API</div>
                        <div className={"row"}>
                            <div className={"col s12 center"} style={{color: '#404040'}}>
                                <p><b>¡Atención!</b> Estas a punto de descargar un archivo txt con la información de viajes listos para ser transmitidos por la API.
                                    Estó generará la actualización de los estados de estos registros.</p>
                                <p>¿Estás seguro de querer continuar?</p>
                            </div>
                            <div className={"col s12 center margin-top-20"}>
                                <button
                                    className={`btn btn-shell-empty z-depth-0`}
                                    onClick={this.closeModal}
                                >Cancelar</button>
                                <button
                                    className={`btn btn-shell z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                                    onClick={this.submitForm}
                                >Continuar</button>
                            </div>
                        </div>
                    </SkyLightStateless>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/sidebar.js